export default __webpack_public_path__ + "img/uqSWQnoP.7bad28da.svg";